import React, { useMemo, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import AddCardForm from '../SharedComponents/AddCardForm';
import { getCurrentAuth0Id } from '../../services/paymentService';
import config from '../../config';

const publicKey = config.config.STRIPE.publicKey;
const connectedAccountID = config.config.STRIPE.connectedAccountID;

// Secure "add / update card" for the Subscription page — saves to Stripe via a
// merchant-scoped setup intent, the same flow as order checkout (AddCardForm).
const SecureAddCard = () => {
  const [saved, setSaved] = useState(false);

  const stripePromise = useMemo(
    () => (publicKey ? loadStripe(publicKey, { stripeAccount: connectedAccountID }) : Promise.resolve(null)),
    []
  );

  return (
    <div
      style={{
        marginTop: 22,
        maxWidth: 820,
        border: '1px solid rgba(0,0,0,.12)',
        borderRadius: 12,
        padding: 18,
        background: '#fff',
        color: '#1a1a1a'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, fontSize: 15 }}>
        <span aria-hidden="true">&#128274;</span>
        <span>Secure payment card</span>
      </div>
      <div style={{ fontSize: 13, color: '#555', margin: '4px 0 12px' }}>
        Add or update the card we charge for your plan. Saved securely to Stripe &mdash; the same way cards are saved at order checkout.
      </div>
      <Elements stripe={stripePromise}>
        <AddCardForm merchantAuth0Id={getCurrentAuth0Id()} onSuccess={() => setSaved(true)} provisionMerchantProfile />
      </Elements>
      {saved ? <div style={{ marginTop: 10, fontSize: 13, color: '#2e7d32' }}>Card saved to your account.</div> : null}
    </div>
  );
};

export default SecureAddCard;
